<template>
    <div class="card_container">
        <div v-if="!imageLoaded" class="img_loader">
            <van-loading color="#fff" type="spinner" size="24px" />
        </div>
        <img :src="props.gameImage" class="gameCard" :style="{ visibility: imageLoaded ? 'visible' : 'hidden' }" alt=""
            @load="onImageLoad" @error="onImageError" @click="gameClickHandle" />
        <div class="heart_icon" @click="addToFavorite">
            <van-loading v-if="isLoading" type="spinner" size="15" />
            <div v-else>
                <img v-if="gameIsFavoriteLocal == 1" src="@/assets/themetwo/icon-fav2.png" alt="">
                <img v-else src="@/assets/themetwo/icon-fav1.png" alt="">
            </div>
        </div>
    </div>
    <LoadingScreen ref="loadingRef" />
    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
</template>

<script setup lang="ts">
import { defineEmits, defineProps, ref, computed, watch } from 'vue'
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { useUserStore } from '@/stores/user';
import { useGameStore } from '@/stores/games';
import { toggleFavorite } from '@/view/game/supportScript';

const emits = defineEmits(['clickGameCard']);
const statusRef = ref();
const isSuccess = ref(false);
const toastContent = ref('');
const loadingRef = ref();
const userStore = useUserStore()
const imageLoaded = ref(false);
const gameStore = useGameStore()
const isLoading = ref(false)
const props = defineProps({
    gameImage: {
        type: String,
        default: () => ''
    },
    gameTypeId: {
        type: [Number, String],
    },
    gameIsFavorite: {
        type: Number
    }
});
const gameIsFavoriteLocal = ref(props.gameIsFavorite);

watch(() => props.gameIsFavorite, (newVal: any) => {
    gameIsFavoriteLocal.value = newVal
})
watch(() => props.gameImage, () => {
    imageLoaded.value = false;
})
const gameClickHandle = () => {
    emits('clickGameCard')
}
const onImageLoad = (e: Event) => {
    imageLoaded.value = true;
};

const onImageError = () => {
    imageLoaded.value = true;
};

const addToFavorite = () => {
    isLoading.value = true
    toggleFavorite({
        userId: userStore.id,
        gameId: props.gameTypeId || '',
        currentStatus: gameIsFavoriteLocal.value || '',
        loadingRef,
        onSuccess: (status, msg) => {
            isLoading.value = false
            gameIsFavoriteLocal.value = status;
            // showSuccess(msg || '');
            gameStore.getGameGroupListData();
        },
        onError: (msg) => {
            showError(msg)
            isLoading.value = false
        }
    });
}

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const showSuccess = (message: string) => {
    toastContent.value = message;
    isSuccess.value = true;
    statusRef.value.open()
}

</script>
<style scoped>
.card_container {
    display: flex;
    justify-content: right;
    width: 100%;
    height: 100%;
    position: relative;
}


.card_container img {
    border-radius: 10px;
    width: 100%;
}

.gameCard {
    width: 100%;
    /* height: 11.5rem; */
    /* object-fit: cover; */
    display: block;
}

.heart_icon {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000000a8;
    border-radius: 0 0 30px 30px;
    padding: 5px;
    margin: 0px 0px 5px -30px;
    height: 20px;
    width: 15px;
}

.heart_icon img {
    width: 16px;
}


.img_loader {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
    background: transparent !important;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: 10px;
}
</style>